import React, { useEffect } from "react";
import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

const ActiveerMaatregelModal = () => {
  useEffect(() => {});

  const handleClick = () => {
    $("#cover-spin").show(0);

    var model = { action: "MAATREGEL_SYNC" };

    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "24c25633-b904-4723-a7fb-693d11b8c293",
      deActiveerMaatregel,
      window.$catalog_management_units_token
    );

    function deActiveerMaatregel() {
      sleep(500).then(() => {
        $("#de_activeer_maatregel").modal("hide");
        window.$catalog_measures_refresh();
        /*omnimap
          .FillTableAction(
            window.$catalog_measures_last_used_table_filter,
            1,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
          });*/
      });
    }
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="de_activeer_maatregel"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{"\u00A0"}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <p>Indien u verder gaat wordt deze maatregel ge(de-)activeerd ?</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_de_activeer_maatregel"
              className="btn-modal"
              onClick={handleClick}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveerMaatregelModal;
